<template>
  <div id="app">
<!--    <audio id="bgm" src="assets/1.mp3" autoplay="autoplay" loop="loop"></audio>-->
    <!--    <video id="video" src="../static/audios/1.mp3" controls="controls"  autoplay="autoplay"  loop="loop"> </video>-->
    <div id="music_icon" class="music-play" @click="toggleBgm()"></div>

    <audio id="bgmusic" autoplay loop="loop" preload="auto" src="http://content.fengchuanba.com/file/box/602/B_602_bgvoice_20160906200433.mp3"></audio>

    <router-view></router-view>
  </div>
<!--    {{is_weixin}}-->
<!--    <div class="isnot_weixin" v-if="!is_weixin">-->
<!--      不是微信客户端！-->
<!--    </div>-->
    <!--    <div style="z-index: 9000" v-if="isShow"  @click="backToIndex()">返回</div>-->

</template>

<script>
import wx from 'weixin-js-sdk'


let shareTitle='2020食品安全周'
let shareDesc='“食品安全，人人有责”线上主题活动'
let shareUrl="https://spzs2020.fengchuanba.com/index.html"
let shareImg="http://content.fengchuanba.com/file/company/44711/20200720/assets/imgs/share/mainmenu.png"
let gameRoute = "/"
if(location.href.indexOf('#')>0){
  gameRoute = location.href.split('#')[1].split('code')[0].split('?')[0];
}

export default {
  name: 'App',
  data(){
    return{
      play:true,
      is_weixin:true,
      showCard:false,
      showGold:false,
      showWelcome:true,
      showLottery:false,
      probability:10,
      isShow:false,
      WECHAT_URL:"/wechat",
    }
  },
  computed:{
    dev(){
      return this.$store.state.dev
    }
  },
  methods:{
      //播放背景音乐：
      toggleBgm:function(){
          let audio = document.getElementById('bgmusic');
          this.play ? (audio.pause(),$('#music_icon').attr('class','music-stop')) : (audio.play(),$('#music_icon').attr('class','music-play'))
          this.play = !this.play
      },

      //微信分享
      getSignature:function(){
          let _this=this;
          if(window.location.href.indexOf('?')>=0){
              if(gameRoute.indexOf('sort')>0){
                  window.location.href="https://spzs2020.fengchuanba.com/index.html#/sort"
                  return;
              }else if(gameRoute.indexOf('card')>0){
                  window.location.href="https://spzs2020.fengchuanba.com/index.html#/card"
                  return;
              }else if(gameRoute.indexOf('receivegold')>0){
                  window.location.href="https://spzs2020.fengchuanba.com/index.html#/receivegold"
                  return;
              }else if(gameRoute.indexOf('elevator')>0){
                  window.location.href="https://spzs2020.fengchuanba.com/index.html#/elevator"
                  return;
              }
             // window.location.href=shareUrl;
             //  return;
          }
          $.ajax({
              url: this.WECHAT_URL + "/getSignature",
              dataType: 'json',
              type: 'GET',
              data: {'url':shareUrl},
              success: function(result){
                  if(result.signature==null){
                      return;
                  }
                  wx.config({
                      // debug: true,
                      appId: 'wx473d4078f39e86d8',
                      timestamp: 1433849398,
                      nonceStr: '426677957',
                      signature: result.signature,
                      jsApiList: [
                          // 'checkJsApi',
                          'onMenuShareTimeline',
                          'onMenuShareAppMessage'
                      ]
                  });

                  wx.ready(function(){
                      if(gameRoute.indexOf('sort')>0){
                        shareTitle='上海市食品安全信息追溯 '
                        shareDesc='食品安全追溯消费者查询分类游戏--“共参与 赢大奖”'
                        shareUrl="https://spzs2020.fengchuanba.com/index.html#/sort"
                        shareImg="http://content.fengchuanba.com/file/company/44711/20200720/assets/imgs/share/sort.png"
                      }else if(gameRoute.indexOf('card')>0){
                         shareTitle='长三角食品安全信息追溯 '
                         shareDesc='“长三角食品追溯对对碰消除游戏--“共参与 赢大奖”'
                         shareUrl="https://spzs2020.fengchuanba.com/index.html#/card"
                         shareImg="http://content.fengchuanba.com/file/company/44711/20200720/assets/imgs/share/card.png"
                      }else if(gameRoute.indexOf('receivegold')>0){
                         shareTitle='上海市废弃物综合管理 '
                         shareDesc='回收地沟油游戏--“共参与 赢大奖”'
                         shareUrl="https://spzs2020.fengchuanba.com/index.html#/receivegold"
                         shareImg="http://content.fengchuanba.com/file/company/44711/20200720/assets/imgs/share/receivegold.png"
                      }else if(gameRoute.indexOf('elevator')>0){
                          shareTitle='上海市智慧电梯 '
                          shareDesc='上海市智慧电梯情景答题--“共参与 赢大奖”'
                          shareUrl="https://spzs2020.fengchuanba.com/index.html#/elevator"
                          shareImg="http://content.fengchuanba.com/file/company/44711/20200720/assets/imgs/share/elevator.png"
                      }
                      wx.onMenuShareAppMessage({
                          title: shareTitle,
                          desc: shareDesc,
                          link: shareUrl,
                          imgUrl: shareImg,
                          success: function () {
                          },
                          cancel: function () {
                          }
                      });

                      wx.onMenuShareTimeline({
                          title: shareTitle,
                          desc: shareDesc,
                          link: shareUrl,
                          imgUrl: shareImg,
                          success: function(){
                          },
                          cancel: function () {
                          }
                      });
                  });
              },
              error: function () {
                  // alert('error');
              }
          });
      },


    startLottery:function(prize){
      //如果中奖了，修改分享后的提示信息
      if (!!prize){
        this.prize = prize;
        this.$store.commit('set_prize',prize);
        this.isPrizeShow = true
      }else{
        this.prize =null;
        this.isPrizeShow = true
      }
      return true//将事件返回到父链中
    },

    backToIndex:function(){
      // this.$router.go(-1)
      this.$router.push('/')
    },
    isWeiXin:function(){//判断是否是微信客户端
        var ua = navigator.userAgent.toLowerCase();
        console.log(ua)
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
            return true;
        } else {
            // this.$router.push('/isNotWechat')
            return false;
        }
    },
    getCodeUrl:function(){
      let code_url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx473d4078f39e86d8"
              +"&redirect_uri=https%3a%2f%2fwechat.fengchuanba.com%2fwechat%2fspzs2020Callback.html"
              +"&response_type=code&scope=snsapi_base&state=0@"+gameRoute+"#wechat_redirect";
      self.location.href=code_url;
    },
    getRegister:function(visitorId){
      $.post('/service/spzs/getRegister', {
        visitorId: visitorId
      }, (data, textStatus, xhr) => {
          // commit("set_pass1",data.register.passgame1)
          // commit("set_pass2",data.register.passgame2)
          // commit("set_pass3",data.register.passgame3)
          // commit("set_pass4",data.register.passgame4)
      })
    }
  },
  watch:{
    $route(now,old){     //监控路由变换，控制返回按钮的显示
      if(now.path=="/"){
        this.isShow=false;
      } else{
        this.isShow=true;
      }
    }
  },
  mounted() {
      //iphone手机自动播放
      document.addEventListener("WeixinJSBridgeReady", function () {
          document.getElementById('bgmusic').play();
      }, false);
      document.addEventListener('DOMContentLoaded', function () {
          function audioAutoPlay() {
              var audio = document.getElementById('bgmusic');
              audio.play();
              document.addEventListener("WeixinJSBridgeReady", function () {
                  audio.play();
              }, false);
          }
          audioAutoPlay();
      });


    if(process.env.NODE_ENV==="production"){
      // if(is_weixin()){
      //   this.$store.commit('set_dev',"weixin")
      // }else{
      //   this.$store.commit('set_dev',"other")
      // }
    }else{
      this.$store.commit('set_dev',"dev")
    }
    //var openId =localStorage.getItem("spzs2020_openid");
    var visitorId = localStorage.getItem("spzs2020_visitorId");

    var wx_code = location.href.split('code')[1];

    if(this.dev=="dev" || location.href.indexOf("2020pad")>0){
      visitorId = 1000000001
      this.$store.commit('set_visitorId',visitorId)
    }

    let _this = this
    // 都没有，就跳转
    if((!visitorId || visitorId==0)&&(!wx_code || wx_code.length<10)){
      this.getCodeUrl();
    }else{
      if(wx_code){
        $.ajax({
          type:'GET',
          //url : "/wechat/getUserInfoByWechatAuth",
          url : "/wechat/getVisitor",
          data:{
            code:wx_code
          }
        }).done(function(data){
          let wx_id = data.openId;
          if(wx_id.indexOf('Error') >= 0){
            this.getCodeUrl();
            return
          }else{

            //localStorage.setItem('spzs2020_openid',wx_id)

            console.log("visitorId = " + data.visitorId)
            localStorage.setItem('spzs2020_visitorId',data.visitorId)
            _this.$store.commit('set_visitorId',data.visitorId)

            visitorId = data.visitorId

            if(location.href.indexOf('code') >=0 || location.href.indexOf('?') >=0){
              self.location.href= "https://"+location.host+"/index.html#" + gameRoute;
            }

            _this.getRegister(visitorId)
          }
        });
      }else{
        if(location.href.indexOf('code') >=0 || location.href.indexOf('?') >=0){
          self.location.href= "https://"+location.host+"/index.html#" + gameRoute;
        }

        this.getRegister(visitorId)
      }
      this.$store.commit('set_visitorId',visitorId)
    }
    //this.is_weixin =this.isWeiXin();

      //这个方法，获得授权，可以在页面加载完成后直接调用
      //只有微信版本才调用
      if(location.href.indexOf("2020pad")<0){
        this.getSignature();
      }
  }
}
</script>

<style>
  @-webkit-keyframes music-rotate
  {
    0%
    {
      -webkit-transform:rotate(0)
    }
    100%
    {
      -webkit-transform:rotate(720deg)
    }
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width:100%;
  height: 100%;
  background: url(http://content.fengchuanba.com/file/company/44711/20200720/static/index/background.jpg);
  background-size:cover;
}
.music-play{
  position: absolute;
  background:url(http://content.fengchuanba.com/file/company/44711/20200720/static/audios/musicplay.png) no-repeat;
  top: 2%;
  left: 86%;
  width: 6%;
  height: 4%;
  background-size: 100% auto;
  z-index:3000;
  /*border: 1px solid red;*/
  /*-webkit-transform-origin:center center;*/
  -webkit-animation:music-rotate 6s linear infinite;
}
  .music-stop{
    position: absolute;
    background:url(http://content.fengchuanba.com/file/company/44711/20200720/static/audios/musicstop.png) no-repeat;
    top: 2%;
    left: 86%;
    width: 6%;
    height: 4%;
    background-size: 100% auto;
    /*border: 1px solid red;*/
    -webkit-transform-origin:center center;
    -webkit-animation:music-rotate 6s linear infinite;
    z-index:3000;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue